import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function SelectField({ label, value, onChange, options, placeholder = "Select…", testid }) {
  return (
    <div>
      {label && <label className="errah-label block mb-2">{label}</label>}
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger
          data-testid={testid}
          className="w-full bg-transparent border border-white/15 rounded-none px-4 h-[46px] text-sm text-white shadow-none focus:ring-1 focus:ring-[#C9A45C] focus:border-[#C9A45C] data-[placeholder]:text-gray-500 hover:border-[#C9A45C]/60 transition-colors"
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="bg-[#141414] border border-white/10 text-white rounded-none">
          {options.map((o) => (
            <SelectItem key={o} value={o} className="text-sm text-gray-300 rounded-none focus:bg-[#C9A45C] focus:text-black cursor-pointer">
              {o}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
